const CARD_WIDTH_MOBILE = 216; // 200px card + 16px gap
const LOOX_READY_DEFAULT_TIMEOUT = 10000;

const STAR_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" class="vp-review-star" aria-hidden="true" focusable="false"><rect width="18" height="18" fill="#0EAB00"/><path d="M4.36863 15.75L5.58738 10.4813L1.49988 6.9375L6.89988 6.46875L8.99988 1.5L11.0999 6.46875L16.4999 6.9375L12.4124 10.4813L13.6311 15.75L8.99988 12.9562L4.36863 15.75Z" fill="white"/></svg>';

function waitForElem(waitFor, callback, minElements = 1, isVariable = false, timer = 30000, frequency = 25) {
  let elements = isVariable ? window[waitFor] : document.querySelectorAll(waitFor);
  if (timer <= 0) return;
  (!isVariable && elements.length >= minElements) || (isVariable && typeof window[waitFor] !== "undefined")
    ? callback(elements)
    : setTimeout(() => waitForElem(waitFor, callback, minElements, isVariable, timer - frequency), frequency);
}

/**
 * Binds progress bar, counter, and prev/next to Swiper (nav elements live outside the swiper root).
 */

function buildFeatureHeighlightSlider(sectionRoot, cardsContainer, sliderClass, navIdPrefix) {
  const cardCount = cardsContainer.children.length;
  if (cardCount === 0) return null;

  const sectionId =
    sectionRoot.dataset.sectionId ||
    (sectionRoot.closest("[id^='shopify-section-']")?.id || "").replace("shopify-section-", "");

  const swiperSlider = document.createElement("swiper-slider");
  swiperSlider.setAttribute("data-swiper-id", "feature-highlight-carousel");
  swiperSlider.className = sliderClass;
  swiperSlider.dataset.swiperConfig = JSON.stringify({
    navigation: {
      enabled: true,
      nextEl: sectionId ? `#${navIdPrefix}-next-${sectionId}` : `[data-${navIdPrefix}-next]`,
      prevEl: sectionId ? `#${navIdPrefix}-prev-${sectionId}` : `[data-${navIdPrefix}-prev]`,
    },
    pagination: { enabled: false },
  });

  const swiperEl = document.createElement("div");
  swiperEl.className = "swiper";

  const wrapper = document.createElement("div");
  wrapper.className = "swiper-wrapper";
  wrapper.setAttribute("role", "list");
  wrapper.id = cardsContainer.id || "";
  wrapper.dataset.blockCount = cardsContainer.dataset.blockCount || String(cardCount);

  while (cardsContainer.firstElementChild) {
    const slide = document.createElement("div");
    slide.className = "swiper-slide";
    slide.appendChild(cardsContainer.firstElementChild);
    wrapper.appendChild(slide);
  }

  swiperEl.appendChild(wrapper);
  swiperSlider.appendChild(swiperEl);
  cardsContainer.parentNode.replaceChild(swiperSlider, cardsContainer);
  return swiperSlider;
}

function bindFeatureHeighlightCarouselPagination(swiper, sectionRoot, selectors) {
  const progressEl = sectionRoot.querySelector(selectors.progress);
  const counterEl = sectionRoot.querySelector(selectors.counter);
  const prevBtn = sectionRoot.querySelector(selectors.prev);
  const nextBtn = sectionRoot.querySelector(selectors.next);

  const update = () => {
    const visibleSlides = Array.from(swiper.slides || []).filter((sl) => sl.style.display !== "none");
    const total = visibleSlides.length;
    let spv = 1;
    if (typeof swiper.params.slidesPerView === "number") {
      spv = Math.floor(swiper.params.slidesPerView);
    }
    let current = swiper.activeIndex + spv;
    current = Math.min(current, total);
    const pct = total > 0 ? (current / total) * 100 : 0;

    if (progressEl) progressEl.style.width = `${pct}%`;
    if (counterEl) {
      counterEl.textContent = `${String(current).padStart(2, "0")}/${String(total).padStart(2, "0")}`;
    }
    // Enable/disable buttons based on position
    const isFirst = swiper.isBeginning;
    const isLast = swiper.isEnd;
    console.log(isFirst, isLast);
    if (prevBtn) {
      prevBtn.disabled = isFirst;
      prevBtn.setAttribute("aria-disabled", isFirst);
    }
    if (nextBtn) {
      nextBtn.disabled = isLast;
      nextBtn.setAttribute("aria-disabled", isLast);
    }
  };

  update();
  swiper.on("slideChange transitionEnd", update);

  if (prevBtn) prevBtn.addEventListener("click", () => swiper.slidePrev());
  if (nextBtn) nextBtn.addEventListener("click", () => swiper.slideNext());
}
function initVpFeatureHeighlightSection(section) {
  const cardsContainer = section.querySelector("[data-vp-feature-heighlight-cards]");
  if (!cardsContainer) return;

  const loader = section.querySelector(".vp-slider-loader");

  const swiperSlider = buildFeatureHeighlightSlider(
    section,
    cardsContainer,
    "vp-feature-heighlight__slider",
    "vp-feature-heighlight",
  );
  if (!swiperSlider) {
    if (loader) loader.classList.add("loaded");
    return;
  }

  setTimeout(() => {
    const swiperInstance = swiperSlider.swiper;
    if (swiperInstance)
      bindFeatureHeighlightCarouselPagination(swiperInstance, section, {
        progress: ".vp-feature-heighlight__pagination-progress",
        counter: ".vp-feature-heighlight__pagination-counter",
        prev: "[data-vp-feature-heighlight-prev]",
        next: "[data-vp-feature-heighlight-next]",
      });
  }, 0);
  if (loader) {
    setTimeout(() => {
      loader.classList.add("loaded");
    }, 300);
  }
}

function initAllFeatureHeighlightSlider() {
  document.querySelectorAll(".vp-feature-heighlight").forEach(initVpFeatureHeighlightSection);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    customElements.whenDefined("swiper-slider").then(initAllFeatureHeighlightSlider);
  });
} else {
  customElements.whenDefined("swiper-slider").then(initAllFeatureHeighlightSlider);
}

document.addEventListener("shopify:section:load", (e) => {
  if (e.target.querySelector(".vp-feature-heighlight")) {
    initAllFeatureHeighlightSlider();
  }
});
